import script from "./UserConfirmComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserConfirmComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserConfirmComponent.vue?vue&type=style&index=0&id=25bdfa8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25bdfa8c"]])

export default __exports__